// extracted by mini-css-extract-plugin
export default {"filterWrapper":"TableFilter_filterWrapper__zE+z-","active":"TableFilter_active__J8GU-","clearIcon":"TableFilter_clearIcon__ep350"};